export enum RuleType {
    RUN_ON_MOUNT = "RUN_ON_MOUNT",
    RUN_ON_SUBMIT = "RUN_ON_SUBMIT",
    RUN_ON_FORM_CHANGE = "RUN_ON_FORM_CHANGE"
}

export interface RuleModel {
    id: string;
    xml: string;
    code: string;
    type?: RuleType;
    relatedFields?: Array<string>;
    runOn?: string[]
}
